<template>
  <footer class="footer container">
    <div class="footer__links-wrapper">
      <router-link class="footer__logo-wrapper" to="/">
        <img class="footer__logo" src="@/assets/images/logo.png" alt="Logo" />
      </router-link>
      <ul class="footer__links links" id="contacts">
        <li class="links__item">
          <router-link to="/projects">Портфолио</router-link>
        </li>
        <li class="links__item" @click="scrollToBlock('faq')">Faq</li>
        <li class="links__item">
          <a
            href="https://www.instagram.com/form.aart?igsh=MTgxb2V6b3dwcnkwcQ%3D%3D&utm_source=qr"
            target="_blank"
          >
            <div class="links__item-icon-wrapper">
              <img src="@/assets/images/social/instagram.png" alt="instagram" />
              *
            </div>
            Instagram
          </a>
        </li>
        <li class="links__item">
          <a href="https://pin.it/51y4GZJvf" target="_blank">
            <img src="@/assets/images/social/pinterest.png" alt="pinterest" />
            Pinterest
          </a>
        </li>
        <li class="links__item">
          <a href="https://t.me/formaartdsn" target="_blank">
            <img src="@/assets/images/social/telegram.png" alt="telegram" />
            Telegram
          </a>
        </li>
        <li class="links__item">
          <a href="mailto:FormaArt.des@yandex.com">Оставить сообщение</a>
        </li>
      </ul>
    </div>
    <div class="footer__privacy privacy">
      <router-link class="privacy__link" to="/privacy-policy">
        <span>Политика конфиденциальности</span> © 2018—{{ currentYear }}
      </router-link>
      <p class="privacy__annotation">
        *Принадлежит компании Meta, которая признана экстремистской организацией
        и запрещена на территории России
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import useScrollToBlock from '@/features/useScrollToBlock'

export default defineComponent({
  name: 'TheFooter',
  setup() {
    const currentYear = computed(() => {
      return new Date().getFullYear()
    })

    return { currentYear, ...useScrollToBlock() }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
